import { getDateMoment, getDestinationTimeZone } from "../../../helpers/dateHelper";
import { SortOrder } from "../../../hooks/useTableSort";
import { VoyageStatus } from "../../../models/booking";

export type VoyagesFilters = {
    dateFrom: Date | null;
    dateTo: Date | null;
    timeZone?: string;
    shipId: string | undefined;
    voyageStatuses: VoyageStatus[];
    rowsPerPage: number;
    page: number;
    order: SortOrder;
};

export function buildVoyagesSearchPayload(filters: VoyagesFilters) {
    const timeZone = getDestinationTimeZone(filters.timeZone);
    const criteria: object[] = [];
    if (filters.shipId) criteria.push({ shipId: filters.shipId });
    const from =
        filters.dateFrom && getDateMoment(filters.dateFrom, { timeZone }).startOf("day").valueOf();
    const to = filters.dateTo && getDateMoment(filters.dateTo, { timeZone }).endOf("day").valueOf();
    if (from != null) criteria.push({ voyageStart: { $gte: from } });
    if (to != null) criteria.push({ voyageEnd: { $lte: to } });
    if (filters.dateFrom && !filters.dateTo) {
        criteria.push({
            voyageStart: {
                $lte: getDateMoment(filters.dateFrom, { timeZone }).endOf("day").valueOf(),
            },
        });
    }
    if (filters.dateTo && !filters.dateFrom) {
        criteria.push({
            voyageEnd: {
                $gte: getDateMoment(filters.dateTo, { timeZone }).startOf("day").valueOf(),
            },
        });
    }
    if (filters.voyageStatuses.length) {
        criteria.push({
            $or: filters.voyageStatuses.map(status => ({ status: status.toString() })),
        });
    }
    return {
        offset: filters.page * filters.rowsPerPage,
        limit: filters.rowsPerPage,
        textSearch: "",
        columns: {},
        order: filters.order,
        filter: { $and: criteria },
    };
}

export function getVoyageExportRange(filters: VoyagesFilters) {
    const timeZone = getDestinationTimeZone(filters.timeZone);
    return {
        from: filters.dateFrom
            ? getDateMoment(filters.dateFrom, { timeZone }).startOf("day").valueOf()
            : 0,
        to: filters.dateTo
            ? getDateMoment(filters.dateTo, { timeZone }).endOf("day").valueOf()
            : Date.now(),
    };
}
